export const SET_CMS_PAGES = "CMS_PAGES/SET_CMS_PAGES";
export const SET_CMS_PAGE = "CMS_PAGES/SET_CMS_PAGE";
export const SET_PAGINATION = "CMS_PAGES/SET_PAGINATION";
